import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { environment } from "../env";
import { toast } from "react-toastify";
import { API } from "./api/api";
import { WithAvatar } from "../components/utils/toasty";

export class NotificationService {
  private key = "notifications-hub";

  public initialize = async (
    context: {
      notificationCount: number;
      setNotificationCount: (count: number) => void;
    },
    navigate: (path: string) => void
  ) => {
    const api = new API();
    const token = await api.acquireToken();

    function handleNotificationReceived() {
      context.setNotificationCount(context.notificationCount + 1);
    }

    if (token) {
      const connection = new HubConnectionBuilder()
        .configureLogging(LogLevel.Debug)
        .withUrl(`${environment.SIGNALR_URL}/${this.key}`, {
          accessTokenFactory: () => token,
        })
        .build();

      connection
        .start()
        .then(() => console.warn("Connected to SignalR hub ", connection))
        .catch((err) => console.error("Error connecting to hub:", err));

      connection.on("ReceiveNotification", (notification) => {
        handleNotificationReceived();
        toast(WithAvatar({ notification }), {
          closeButton: true,
          progress: undefined,
          position: "top-right",
          autoClose: 30000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          onClick: () => navigate("contacts/notifications"),
          className:
            "shadow-lg overflow-visible scale-100 ring-1 ring-black/5 rounded-xl flex items-center gap-6 ",
        });
      });
    }
  };
}
